import Layout from '@/layout/index.vue'

export const ActeAditionaleRoute =
    {
      path: '/acte-aditionale',
      component: Layout,
      redirect: '/acte-aditionale',
      children: [
        {
          path: 'view/:actAditionalID',
          component: (): Promise<any> =>
            import(/* webpackChunkName: "acte-aditionale" */ '@/features/acte-aditionale/views/details.vue'),
          name: 'ActAditionalDetailsRoute',
          meta: {
            title: 'Detalii act adițional',
            requiresAuth: true
          }
        },
        {
          path: 'create/:contractId',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "acte-aditionale-create" */
              '@/features/acte-aditionale/views/create-update-act.vue'),
          name: 'CreateActAditionalForContractRoute',
          meta: {
            title: 'Adăugare act adițional',
            requiresAuth: true,
            action: 'create'
          }
        },
        {
          path: 'update/:actAditionalId',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "acte-aditionale-update" */
              '@/features/acte-aditionale/views/create-update-act.vue'),
          name: 'UpdateActAditionalForContractRoute',
          meta: {
            title: 'Modificare act adițional',
            requiresAuth: true,
            action: 'update'
          }
        }
      ]
    }
